import { connect } from 'react-redux'
import { getCustomContent } from './actions'
import CustomPage from './CustomPage'

const mapStateToProps = state => {
  const { features } = state.appReducer
  const customPage = features ? features.find(f => f.id === 'customPage') : {}
  return {
    isGetCustomContentInProgress: state.customPage.isGetCustomContentInProgress,
    getCustomContentResponse: state.customPage.getCustomContentResponse,
    featuresAndOptions: state.appReducer.featuresAndOptions,
    customPageTitle: customPage.title || '',
  }
}

const mapDispatchToProps = {
  getCustomContent,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomPage)
